// extracted by mini-css-extract-plugin
export default {"wrapper":"add-data_wrapper__PE6jd","callback":"add-data_callback__nlcFD"};